import { createAction } from 'redux-actions';

export const SET_CATEGORIES = 'CATEGORIES_LIST::SET';
export const SELECT_CATEGORY = 'CATEGORIES_LIST::SELECT_CATEGORY';

export const setCategoriesList = createAction(SET_CATEGORIES);
export const selectCategory = createAction(SELECT_CATEGORY);
